import React from "react";
import { useSelector } from "react-redux";
import { AutoComplete, SelectProps } from "antd";
import useDebounce from "../../../../customhooks/useDebounce/useDebounce";
import { searchUserInSchool } from "../../../../api/school/school";
import { selectChatSocket } from "../../../../store/webSocketSlice/webSocketSlice";
import { selectUser } from "../../../../store/userSlice/userSlice";

function ChatSearch() {
  const chatSocket = useSelector(selectChatSocket);
  const user = useSelector(selectUser);

    const [options, setOptions] = React.useState<SelectProps<object>['options']>([]);

  const handleSearch = useDebounce(async(userName: any) => {
    try {
      const res = await searchUserInSchool({userName})
      const data = res.data.data.map((item: any) => ({
        value: item._id,
        label: `${item.userName} - ${item.firstName}`
      }));
      console.log(data)

      setOptions(data);

    } catch (error) {}
    finally{

    }
  }, 1000);

  const onSelect = (value: string) => {
    console.log("onSelect", value);

    // emit start chat
    chatSocket?.emit("start_new_chat", {
      data: {
        userId: user._id,
        recieverId: value,
      }
    });
  };
  return (
    <div>
      <AutoComplete
        popupMatchSelectWidth={252}
        style={{ width: 300 }}
        options={options}
        onSelect={onSelect}
        onSearch={(e) => {
          handleSearch(e);
        }}
      />
    </div>
  );
}

export default ChatSearch;
